import { withAnalytics } from 'components/common/analytics';
import { BooleanButton } from 'components/sign-up/components/phone-number/boolean-buttons/boolean-button';
import { compose } from 'redux';

const enhance = compose(withAnalytics);
const BooleanButtonContainer = enhance(BooleanButton);

export { BooleanButtonContainer };
